import type { ParagraphTextStats as ParagraphTextStatsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import styles from "./ParagraphTextStats.module.css";

/**
 * Layout 36 - `PARAGRAPH_TEXT_STATS_LAYOUT`: tekst + 4 boksy statystyk.
 *
 * Struktura:
 *   - Grid 2-kolumny: tekst po lewej / 4 karty statystyk 2x2 po prawej
 *   - Kolumna tekstu (lewa):
 *       - Eyebrow (text_1) - uppercase label nad tytulem
 *       - Title h2 (name) - plain text
 *       - Desc (text) - HTML z TinyMCE
 *   - Kolumna kart (prawa) - grid 2x2 z 4 kartami statystyk:
 *       - Value - duza wartosc (np. "12 lat", "100%")
 *       - Label - opis pod wartoscia
 *   - Puste karty (bez value i label) sa filtrowane po backendzie.
 */
export function ParagraphTextStats({
  paragraph,
}: {
  paragraph: ParagraphTextStatsData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, name: title, text: desc, stats, color_variant: variant } = paragraph;
  const hasStats = Array.isArray(stats) && stats.length > 0;
  const hasDesc = desc && desc.trim() !== "";
  const hasEyebrow = eyebrow && eyebrow.trim() !== "";

  return (
    <section className={styles.section} data-variant={variant ?? "default"}>
      <div className={styles.inner}>
        <div className={styles.text}>
          {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
          {title ? <h2 className={styles.title}>{title}</h2> : null}
          {hasDesc ? (
            <HtmlText html={desc} className={styles.desc} />
          ) : null}
        </div>
        {hasStats ? (
          <div className={styles.cards}>
            {stats.map((s, idx) => (
              <div key={idx} className={styles.card}>
                {s.value ? <div className={styles.value}>{s.value}</div> : null}
                {s.label ? <div className={styles.label}>{s.label}</div> : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
